export enum EnableFlowMinEnum {
  OFF,
  ON,
}
